import { useSelector } from "react-redux";

  export const useAdminUserDetails = () =>
  useSelector((state) => state.adminUserSlice.adminUserData);

  export const useDashboardLoadingState = () =>
  useSelector((state) => state.MemberSlice.loadingStatus);

  export const useMCMemberList = () =>
  useSelector((state) => state.MemberSlice.memberList);